import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

export interface StatusOption {
  key: string;
  label: string;
  active?: boolean;
}

export interface ActionButton {
  label: string;
  severity?: 'primary' | 'secondary' | 'success' | 'info' | 'danger';
  outlined?: boolean;
  disabled?: boolean;
  show?: boolean;
  icon?: string; // Material Symbols icon class name
}

@Component({
  selector: 'app-status-filter',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    SelectButtonModule,
    TranslateModule,
  ],
  templateUrl: './status-filter.component.html',
  styleUrl: './status-filter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusFilterComponent implements OnInit {
  @Input() statusOptions: StatusOption[] = [];
  @Input() primaryButton?: ActionButton;
  @Input() secondaryButton?: ActionButton;

  @Output() statusChange = new EventEmitter<string>();
  @Output() primaryButtonClick = new EventEmitter<Event>();
  /** Canonical secondary-button output used by most screens. */
  @Output() secondaryButtonClick = new EventEmitter<Event>();
  /** Legacy alias kept for screens that still bind (secondaryonClick). */
  @Output() secondaryonClick = this.secondaryButtonClick;

  activeKey = '';

  ngOnInit() {
    this.activeKey =
      this.statusOptions.find((s) => s.active)?.key ??
      this.statusOptions[0]?.key ??
      '';
  }

  onSelectChange(key: string) {
    this.statusOptions.forEach((s) => (s.active = s.key === key));
    this.statusChange.emit(key);
  }

  onprimaryButtonClick(event: Event): void {
    this.primaryButtonClick.emit(event);
  }

  onSecondaryButtonClick(event: Event): void {
    this.secondaryButtonClick.emit(event);
  }
}
